/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import SwitchField from "components/SwitchField";
import SelectField from "components/SelectField";
import { useEffect, useState } from "react";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import DatepickerField from "components/DatepickerField";
import Footer from "./components/footer";

export default function ForeignSupplier01() {
  const { formId, formField } = form;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([]);
  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế đối với hoạt động kinh doanh thương mại điện tử tại Việt Nam (03/NCCNN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Dành cho Ngân hàng thương mại, tổ chức cung ứng dịch vụ trung gian thanh toán khấu
                trừ và nộp thuế thay cho Nhà nước cung cấp ở nước ngoài)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
const cityOption = [
  { value: "cityA", label: "Thành phố A" },
  { value: "cityB", label: "Thành phố B" },
  { value: "cityC", label: "Thành phố C" },
  { value: "cityD", label: "Thành phố D" },
];
const districtOption = [
  { value: "district", label: "Quận A" },
  { value: "district", label: "Quận B" },
  { value: "district", label: "Quận C" },
  { value: "district", label: "Quận D" },
];
const wardOption = [
  { value: "ward", label: "Phường A" },
  { value: "ward", label: "Phường B" },
  { value: "ward", label: "Phường C" },
  { value: "ward", label: "Phường D" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxCalculationPeriod, firstTime, supplementaryForThe, bank, taxId } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={bank.name}
            label={bank.label}
            value={values.bank}
            error={errors.bank && touched.bank}
            success={values.bank?.toString().length > 0 && !errors.bank}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
